import ajax from "ajax"
import rollbar_helper from "rollbar_helper"
import signals from "signals"
import intervals from "intervals"
import vimeo_manager from "vimeo_manager"
import timeouts from "timeouts"

const track_consumed = (media, slug) => {
  signals.emit("kenhub.content_consumed", {media, slug})
  if (!window.gon.current_user) return
  return ajax.post("/content_tracking/consumed", {media, slug})
}

export const track_consumed_article = (slug) => {
  if (!slug) return
  return timeouts.set(() => track_consumed("article", slug), 2 * 60 * 1000)
}

export const track_consumed_video = (slug, iframe) => {
  if (!slug) return
  let tracking_count = 0
  const interval = intervals.set(() => {
    const viewed = vimeo_manager.get_percentage_viewed(iframe)
    if (viewed > 0.25) {
      tracking_count++
      if (tracking_count === 2) {
        rollbar_helper.send_error_msg(
          "clearInterval doesn't work",
          {viewed, interval}
        )
      }
      track_consumed("video", slug)
      clearInterval(interval)
    }
  }, 1000)
}
